import iconv from 'iconv-lite';
import KanaMap from '../../resources/kana_map.json';
const CHAR_CODE_BACKQUOTE = 0x60;

export class Kana {
    static toFullWidthKatakana(str: string) {
        for (let half in KanaMap) {
            const full = KanaMap[half as keyof typeof KanaMap];
            str = str.replace(new RegExp(half, 'g'), full);
        }
        return str.replace(/[\u3041-\u3096]/g, (hiragana) => {
            const code = hiragana.charCodeAt(0) + CHAR_CODE_BACKQUOTE;
            return String.fromCharCode(code);
        });
    }

    static toKatakana(input: string): string {
        return input.replace(/[\u3041-\u3096]/g, (char) => {
            return String.fromCharCode(char.charCodeAt(0) + 0x60);
        });
    }

    static toHalfWidthAlphaNumeric(input: string): string {
        return input.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (char) => {
            return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
        });
    }
}

export function extractEncodable(src: string, encode: string): string {
    const buf = iconv.encode(src, encode);
    const recover = iconv.decode(buf, encode);
    return recover.replace(/\?/g, '');
}
